import React,{ useState, useEffect } from 'react';
import { 
    notification,
    Flex, 
    Modal,
    Button, 
    Spin } from 'antd';
import Slider from "react-slick";
import axios from 'axios';
import PhoneProductCard from './PhoneProductCard';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const siteDomain = headerVars.siteDomain;

function PhoneServices( { /*setCartContents*/ } ) {
    let [productList, setproductList] = useState([]);
    let [productData, setProductData] = useState([]);
    let [cartUpdateState, setcartUpdateState] = useState('');
    let [spinnerDisplay, setSpinnerDisplayState] = useState('');
    let [loadingCart, setLoadingCart] = useState(false);
    let [cardLoadingDisplay, setCardLoadingDisplayState] = useState(false);
    let [cardVisibility, setCardVisibility] = useState(true); 
    let [activeProductName, setActiveProductName] = useState(false); 
    let [activeProductID, setActiveProductID] = useState(''); 
    let [addingToCart, setAddingToCart] = useState(false);
    let [modalContent, setModalContent] = useState(<></>);
    let [modalOpen, setModalOpen] = useState(false);
    let [modalTitle, setModalTitle] = useState('');
    let [modalWidth, setModalWidth] = useState(500); 
    let [modalFooter, setModalFooter] = useState([]);

    let sliderSettings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 2.5,
        slidesToScroll: 2,
        initialSlide: 0,
        responsive: [{
            breakpoint: 1024,
            settings: {
              slidesToShow: 2.2,
              slidesToScroll: 2,
              initialSlide: 0
            }
          },{
            breakpoint: 900,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
              initialSlide: 0
            }
          },{
            breakpoint: 768,
            settings: {
              slidesToShow: 1.2,
              slidesToScroll: 1,
              initialSlide: 0
            }
          },{
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 0
            }
          },{
            breakpoint: 475,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 0
            }
          },{
            breakpoint: 410,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 0
            }
          },
        ]
    };

    const [api, contextHolder] = notification.useNotification();

    useEffect(() => {
        let form_data = new FormData;
        form_data.append('action', 'startca_get_phone_products');
        let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};
        //buildProductList( [], '', false );

        axios
        .post(requestUrl.ajax_url, form_data)
        .then(function(response){
            let products = response.data;
            //console.log("products:: ", products);

            if( products.length ) {
                //buildProductList( products, '', false );
                setProductData( products );
            } else {
                setCardVisibility(false);
                setProductData( [] );
                //buildProductList( products, '', false );
            }
        })
        .catch(function (error) {
            console.log(error);
        })
        .finally(function () {
            // always executed 
        }); 
    }, [cardVisibility]);

    const openNotification = ( placement, productName ) => {
        api.info({
            message: productName,
            description: `Has been added to your cart.`,
            placement
            
        });
    }

    const openChannelDetailsNotification = ( placement, channel ) => {
        console.log('channel:: ', channel);
        let cleanDesc = channel['description'].replace(/<\/?[^>]+(>|$)/g, "");
        console.log('cleanDesc:: ', cleanDesc);
        setModalOpen(true);
        setModalWidth(1000);
        setModalTitle("");
        setModalFooter([]);
        setModalContent(
            <div className='channel-modal-content'>
                <div className='channel-modal-img-container' >
                    <img src={ channel[ 'logo' ] } />
                </div>
                <div className=''>
                    <h3>{ channel['title'] }</h3>
                    <p>{ cleanDesc }</p>
                </div>
            </div>
        );
    }

    const buildProductList = () => {
        let productList = [];
        let productCard = '';

        if( cardVisibility ) {
            if(productData.length <= 0 ) {
                for( var i=0; i < 3; i++ ) {
                    productCard = 
                    <PhoneProductCard 
                        handleAddToCart={ handleAddToCart } 
                        productData={ [] }
                        activeProductId={ 0 }
                        addingToCart={ false }
                        isLoading={ true }
                        isPlaceholder={true}
                    />
                    productList.push(productCard);
                }
            } else {
                for( var i=0; i < productData.length; i++ ) {
                    productCard = 
                    <PhoneProductCard
                        handleAddToCart={ handleAddToCart } 
                        productData={ productData[i] }
                        activeProductId={ activeProductID }
                        addingToCart={ addingToCart }
                        isLoading={ cardLoadingDisplay }
                        isPlaceholder={ false }
                    />
    
                    productList.push(productCard);
                }
            }
        }

        return productList
        //setproductList( productList );
    }

    /*const handleChannelDrawerClose = () => {
        setChannelDrawerOpen( false );
    }*/

    const updateCartIcon = ( cartServiceQuantity ) => {
        jQuery( '.header-cart-icon' ).html('<span class="cart-contents-quantity">'+cartServiceQuantity+'</span>');
    }

    const handleShowCheckAvailability = (  ) => {
        document.dispatchEvent(new CustomEvent('qualificationModalUpdateState', { detail: 'standalone_phone_purchase_attempt' }));
    }

    const handleAddStandaloneTVToCart = ( productId, productName ) => {
        let form_data = new FormData;
        let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};
        setLoadingCart( true );
        setAddingToCart( true );
        
        setModalOpen(false);

        form_data.append('action', 'startca_add_standalone_product_to_cart');
        form_data.append( 'id', productId );
        form_data.append( 'product_type', 'phone' );

        axios
        .post(requestUrl.ajax_url, form_data)
        .then(function(response){
            console.log(response.data);

            let serviceCount = response.data['service_count'];
            let action = response.data['action'];

            setLoadingCart(false);
            //addingToCart = false;
            setAddingToCart( false );
            //buildProductList(products, productId, addingToCart);
            openNotification('topLeft', productName);
            updateCartIcon( serviceCount );

            
        })
        .catch(function (error) {
            console.log(error);
            //setLoadingCart(false);
            setAddingToCart( false );
            //addingToCart = false;
        })
        .finally(function () {
            // always executed
        }); 
    }
    
    const handleAddToCart = ( productId, productName ) => {
        let form_data = new FormData;
        let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};

        form_data.append('action', 'startca_add_to_cart');
        form_data.append( 'id', productId );
        //addingToCart = true;
        setAddingToCart( true );
        setActiveProductID(productId);
        //buildProductList(products, productId, addingToCart);

        //console.log("productName:: ", productName);
        //console.log("productID:: ", productId);
    
        axios
        .post(requestUrl.ajax_url, form_data)
        .then(function(response){
            console.log(response.data);
            addingToCart = false;
            let serviceCount = response.data['service_count'];
            let action = response.data['action'];
            
            switch( action ) {
                case 'missing-internet' :
                    setModalOpen(true);
                    setModalWidth(500);
                    setModalTitle("Something's missing");
                    //addingToCart = false;
                    setAddingToCart( false );
                    setModalFooter([
                        <Button 
                            type="primary" 
                            class="change-info-button internet-package-check-availability-button"
                            //style={ { display: paymentReceived ? 'none' : 'block' } }
                            onClick={ handleShowCheckAvailability }
                        >
                            Switch today
                        </Button>,
                        <Button 
                            type="default" 
                            loading={ loadingCart }
                            onClick={ () => handleAddStandaloneTVToCart( productId, productName ) }
                        >
                            I'm already a Fibre customer
                        </Button>,
                    ]);
                    setModalContent(
                        <div className=''>
                            <p>Start Home Phone is only available to Start Fibre internet customers.</p>
                        </div>
                    );
                break;
                case 'product-added':
                openNotification('topLeft', productName);
                setAddingToCart( false );
                updateCartIcon( serviceCount );
                break;
            }

        })
        .catch(function (error) {
            console.log(error);
            //addingToCart = false;
            setAddingToCart( false );
        })
        .finally(function () {
            // always executed
        }); 
    }; 

    const handleModalCancel = () => {
        setModalOpen(false);
        setAddingToCart( false );
    }

    return (
        <div className="react-service-details-internet">
            { contextHolder }

            <Flex horizontal justify='center'>
                <div className={`spinner ${spinnerDisplay}`}>
                    <Spin size="large"/>
                </div>
            </Flex>

            <Slider { ...sliderSettings }>
                { buildProductList() }
            </Slider>
            <Modal
                title={ modalTitle }
                centered
                open={ modalOpen }
                onCancel={ handleModalCancel }
                width={ modalWidth }
                footer={ modalFooter }
            >
                { modalContent }
            </Modal>
        </div>
    )
}

export default PhoneServices